import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { FbSqUser } from 'types/SqGame.types';

export const userToDoc = (user: FbSqUser): DocumentData => {
  return {
    uid: user.uid,
    email: user.email,
    name: user.name,
    emailVerified: user.emailVerified,
    isAnonymous: user.isAnonymous,
    isEditor: user.isEditor,
    createdOn: user.createdOn,
    modifiedOn: user.modifiedOn,
  };
};

export const userConverter: FirestoreDataConverter<FbSqUser> = {
  toFirestore(user: FbSqUser): DocumentData {
    // return { ...gameToDoc(game), ...getModifiedInfo() };
    return userToDoc(user);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): FbSqUser {
    const user = docSnap.data(options);

    return {
      uid: user.uid,
      email: user.email,
      name: user.name,
      emailVerified: user.emailVerified,
      isAnonymous: user.isAnonymous,
      isEditor: user.isEditor,
      createdOn: user.createdOn,
      modifiedOn: user.modifiedOn,
    };
  },
};
